import React from 'react';
import styled from 'styled-components';
import { Icon, IconLookup } from 'component-library-and-tools';

import FlowLabeledContent from '../FlowLabeledContent';

import { FlowArrowProps } from './types';

const LABELED_CONTENT_CONTAINER = 'flow-labeled__content-container';

const StyledContainer = styled.div`
  padding: 1.666666667rem 1rem;
`;

const StyledFlowLabeledContent = styled(FlowLabeledContent)`
  & .${LABELED_CONTENT_CONTAINER} {
    display: flex;
    justify-content: center;
  }
`;

const StyledIcon = styled(Icon)`
  && {
    color: #d7dae0;
    font-size: 1.666666667rem;
    font-weight: 700;
  }
`;

const FlowArrow = ({
  hideLabel,
  label,
}: FlowArrowProps) => {
  const arrowElement = <StyledIcon icon={IconLookup.ARROW_RIGHT} />;

  return (
    <StyledContainer>
      {hideLabel
        ? arrowElement
        : <StyledFlowLabeledContent
            label={label}
            contentContainerClassName={LABELED_CONTENT_CONTAINER}
          >
            {arrowElement}
          </StyledFlowLabeledContent>
      }
    </StyledContainer>
  );
};

export default FlowArrow;
